import React, { useState, useEffect, useRef } from 'react';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import PropTypes from 'prop-types';
import { h5PageCount } from 'ThreeTerminal_utils';
import errorBoundary from '@ifeng/errorBoundary';
import { CallupHead, SimpleGuideLayer, PageBottomBrand } from 'ThreeTerminal_mobile_dynamic';
import { formatVideoDuration, handleNativeTitleClick, getWebTitleUrl, limitWords } from './utils';
import styles from './index.css';
import { withBottomSlide } from '@ifeng/container_channel/common/client/components/withBottomSlide';
import { getHotNewsData, formatHotNewsData, getQueryString } from '../../../services/api';
import Grounds from '@ifeng/three_terminal/es/base/grounds';
import { callApp, getSchemeLink } from '@ifeng/callapp';
import NoSSR from 'react-no-ssr';
import 'intersection-observer';

const FROM = getQueryString('form', '');
const isFromHome = FROM === 'homeHeadline';
const PAGES = {
    hot: {
        staId: 'hot_merge',
        api: 'https://nine.ifeng.com/hotspotlist',
        method: 'get',
        title: '凤凰热榜',
    },
};

const isBrowser = typeof window !== 'undefined';
const PAGE_INFO = PAGES.hot;
const staRecord = {}; // 曝光统计
let fromSSR = true;
const Expose = new Grounds.Expose();
const typesMap = {
    doc: 'article',
    phvideo: 'video',
    topic2: 'topic',
    topic3: 'topic',
    slide: 'pic',
    hotspotlist: 'newsgroup',
    short: 'shortdoc',
};

const NewsFlow = errorBoundary(({ list, loadMore, handleCallUp, storeClickedItem, isClient }) => {
    let newsFlowBtm = useRef(null);
    let intersectionObserver = isBrowser
        ? new IntersectionObserver(entries => {
              if (entries[0].intersectionRatio <= 0) return;
              loadMore();
          })
        : null;
    const staList = (item, index) => ({
        id: item.staticId,
        rnum: index,
        reftype: encodeURI(item.reftype),
        showtype: 'hotspottitleimg',
        src: encodeURI(item.source),
        ch: 'hot_merge',
        pagetype: typesMap[item.link.type] || item.link.type,
    });

    useEffect(() => {
        if (!intersectionObserver) return;
        intersectionObserver.observe(newsFlowBtm.current);

        return () => intersectionObserver.disconnect();
    }, []);

    const ArticleContent = ({ item, index }) => {
        const content = (
            <div className={styles.content}>
                <div className={`${styles.left} ${!item.thumbnail ? styles.left_long : null}`}>
                    <div>{item.title}</div>
                    <div>
                        {index > 2 && FROM === 'homeHeadline' && <span>打开APP阅读</span>}
                        <span>{item.source}</span>
                    </div>
                </div>
                {item.thumbnail ? <img src={item.thumbnail} alt="" /> : null}
                {item.type === 'video' ? (
                    <div className={styles.icon}>
                        <img src={require('../assets/video_icon.png')} alt="" />
                        <div>{formatVideoDuration(item?.phvideo.length)}</div>
                    </div>
                ) : null}
                {item.type === 'slide' ? (
                    <div className={styles.icon}>
                        <img src={require('../assets/imgs_icon.png')} alt="" />
                        <div>{item?.thumbnails.length}</div>
                    </div>
                ) : null}
            </div>
        );

        if (isClient) {
            return (
                <div
                    onClick={() => {
                        Grounds.dispatch(item.link.type, item.link.url, {
                            showtype: 'hotspottitleimg',
                            ref: 'hot_merge',
                        });
                    }}>
                    {content}
                </div>
            );
        } else {
            return <a href={item.url}>{content}</a>;
        }
    };

    ArticleContent.propTypes = {
        item: PropTypes.object,
        index: PropTypes.number
    };

    return (
        <div className={styles.newsflow}>
            <Expose.Container staList={staList} viewPort={null}>
                {list.slice(0, 30).map((item, index) => {
                    return (
                        <div
                            key={index}
                            onClick={e => {
                                if (!isClient) {
                                    storeClickedItem(item);
                                    if (window.allData.unfoldType.hotNewsBreak !== '1') handleCallUp(e, index > 2);
                                }
                            }}>
                            <a
                                href={getWebTitleUrl(item)}
                                onClick={e => {
                                    if (isClient) handleNativeTitleClick(item, e);
                                }}>
                                <div
                                    className={`${styles.newsflow_header} ${
                                        index >= 10 ? styles.newsflow_header_op : null
                                    }`}>
                                    <img src={require(`../assets/${index + 1}.png`)} alt="" />
                                    <div className={styles.arrow}>
                                        {item.hotLabel?.hotTrend === '1' ? (
                                            <div>
                                                <span>{item.hotLabel?.hotGrade}</span>
                                                <img src={require('../assets/up_arrow_icon.png')} alt="" />
                                            </div>
                                        ) : null}
                                        {item.hotLabel?.hotTrend === '0' ? (
                                            <div className={styles.down}>
                                                <span>{item.hotLabel?.hotGrade}</span>
                                                <img src={require('../assets/down.png')} alt="" />
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className={`${styles.main_title} ${styles.main_title_border_fix}`}>
                                    <img
                                        className={/topic/.test(item.hotLabel?.link.type) ? styles.topic_fix : null}
                                        src={require(`../assets/${
                                            /topic/.test(item.hotLabel?.link.type) ? 'topic_icon' : 'event'
                                        }.png`)}
                                        alt=""
                                    />
                                    <div>{limitWords(item.hotLabel?.desp.replace(/#/g, ''), 14)}</div>
                                    <img src={require('../assets/arr_title.png')} alt="" />
                                </div>
                            </a>
                            <ArticleContent item={item} index={index} />
                        </div>
                    );
                })}
            </Expose.Container>
            <div style={{ padding: 0 }} ref={ele => (newsFlowBtm.current = ele)} />
            <div className={styles.bottom}>
                <img src={require('../assets/bottom.png')} alt="" />
            </div>
        </div>
    );
});

export const CallUpTip = errorBoundary(({ close, title, rightText, enterSta, isVideoShare }) => {
    const staticHandler = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        enterSta();
        const client = isVideoShare ? 'videoApp' : 'newsApp';
        const downloadVal = isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1447785374780',
                  downloadAd: `https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=${
                      isFromHome ? 8831 : 8778
                  }`,
              };

        if (isCallApp) {
            callApp({
                client,
                docType: 'hotNewsRank',
                kind: isFromHome ? 'inter_sflahuo04' : 'inter_fxy05',
                pid: 'https://nine.ifeng.com/hotnewsrank',
                noKindFrom: 1,
                download: downloadVal.download,
                downloadAd: downloadVal.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    return (
        <div className={styles.calluptip}>
            <div className={styles.content}>
                <div>{title}</div>
                <div className={styles.btns}>
                    <div onClick={() => close()}>取消</div>
                    <div onClick={() => staticHandler()}>{rightText}</div>
                </div>
            </div>
        </div>
    );
});

const TipsNotFound = errorBoundary(({ close }) => {
    const [count, setCount] = useState(3);

    useEffect(
        () => {
            setTimeout(() => {
                if (count <= 1) {
                    return close();
                }
                setCount(count - 1);
            }, 1000);
        },
        [count],
    );

    return (
        <div className={styles.notFound}>
            <div className={styles.content}>
                <img src={require('../assets/404.png')} alt="" />
                <div>{count}秒后为您推荐今日热点</div>
                <div>对不起, 该网页随风而逝......</div>
            </div>
        </div>
    );
});

// 修复安卓状态栏高度问题
const fixAndroidStateBar = (function fixAndroidStateBar() {
    if (!isBrowser || !window.grounds || !window.grounds.getStatusBarHeight) return null;

    const stateBarHeight = window.grounds.getStatusBarHeight() / window.devicePixelRatio;

    return `${stateBarHeight}px`;
})();

const FixedHeader = errorBoundary(({ isClient, content }) => {
    const [scrollTop, setScrollTop] = useState(0);
    const isIOS = isBrowser && window.grounds && /ios/.test(Grounds.getDeviceInfo().getOs());
    const fixedPadding = fixAndroidStateBar;

    if (!isClient) return null;

    const scrollTopHandler = e => {
        if (window.scrollY < 50) setScrollTop(0);
        if (80 < window.scrollY && window.scrollY < 180) {
            let op = (window.scrollY - 80) / 50;

            setScrollTop(op < 1 ? op : 1);
        }
        if (window.scrollY > 180) setScrollTop(1);
    };

    useEffect(() => {
        window.addEventListener('scroll', scrollTopHandler);

        return () => window.removeEventListener('scroll', scrollTopHandler);
    }, []);

    return (
        <div
            className={`${styles.fixed_header} ${!isIOS ? styles.fixed_header_android : null}`}
            style={{ display: scrollTop < 0.1 ? 'none' : 'block', opacity: scrollTop, paddingTop: fixedPadding }}>
            <div className={styles.title}>凤凰热榜</div>
            <div className={styles.btn}>
                <img
                    src={require('../assets/back_black.png')}
                    alt=""
                    onClick={() => {
                        Grounds.close();
                    }}
                />
                <img
                    src={require('../assets/share_black.png')}
                    alt=""
                    onClick={() => {
                        const appName = Grounds.getAppName();
                        const isVideo = /video/.test(appName);

                        Grounds.openShare(
                            `https://ishare.ifeng.com/hotNewsRank${isVideo ? '/vs' : ''}`,
                            content.shareInfo.desc,
                            '来自凤凰新闻客户端',
                            'https://x0.ifengimg.com/fe/custom/share.jpg',
                            PAGE_INFO.staId,
                        );
                    }}
                />
            </div>
        </div>
    );
});

@withBottomSlide
class Layout extends React.PureComponent {
    state = {
        page: 1,
        isEnd: false,
        type: 'hot',
        showCallUpTip: false,
        show404Tips: isBrowser ? /hotNewsShare404/.test(location.pathname) : false,
    };

    static propTypes = {
        content: PropTypes.object,
        getFooterSlideData: PropTypes.func,
        setWechatConfig: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.clickedItem = null;
        this.clickedItemInfo = null;

        try {
            props.content.content.list = formatHotNewsData(props.content.content.list);
            this.state.content = props.content.content;
            this.state.allData = props.content;
        } catch (err) {
            console.error('ssr error');
        }
    }

    init = data => {
        const { isClient } = this.state.allData;
        const is404Page = /hotNewsShare404/.test(location.pathname);
        const {
            content: { isVideoShare },
        } = this.props;

        if (!isClient) {
            this.props.getFooterSlideData({
                title: (data.shareInfo && data.shareInfo.desc) || PAGE_INFO.title,
                id: PAGE_INFO.title,
                from: 'share_relate_foot_rjsy',
                staId: (data.shareInfo && data.shareInfo.chid) || '',
            });

            this.props.setWechatConfig({
                title: '凤凰热榜',
                img: (data.shareInfo && data.shareInfo.thumbnail) || '',
                desc: data.shareInfo.desc || '',
            });
        }

        if (isClient) {
            const fromShare = getQueryString('fromShare', '');

            Grounds.pageStat({
                id: PAGE_INFO.staId,
                type: 'newsgroup',
                ref: fromShare ? 'outside' : 'https://nine.ifeng.com/hotSpotList',
            });
        } else {
            h5PageCount([
                {
                    datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
                    behavior: 'page',
                    type: 'h5',
                    other: {
                        id: PAGE_INFO.staId,
                        tag: 't42',
                        url: encodeURIComponent(location.href),
                        ref: is404Page ? 'error_404' : encodeURIComponent(location.href),
                    },
                },
            ]);
        }
    };

    componentDidMount() {
        this.loadMore();

        const startTime = new Date().getTime();

        if (isBrowser) {
            window.addEventListener('load', () => {
                window.addEventListener(
                    'popstate',
                    () => {
                        const endTime = new Date().getTime();

                        if (endTime - startTime > 200) {
                            location.reload();
                        }
                    },
                    false,
                );
            });
        }
    }

    storeClickedItem = item => {
        this.clickedItemInfo = item;
    };

    enterSta = () => {
        h5PageCount([
            Object.assign(this.clickedItemInfo.clickCount, {
                type: 'enter',
            }),
        ]);
    };

    toggleCallUpTip = (type, ele = null) => {
        if (ele) this.clickedItem = ele.target;
        this.setState({
            showCallUpTip: type,
        });
    };

    handleCallUp = (e, forceCallup) => {
        const { type, showCallUpTip } = this.state;
        const {
            content: { isVideoShare },
        } = this.props;

        if (type !== 'hot' || showCallUpTip || isVideoShare) return false;

        e.preventDefault();

        if (forceCallup && FROM === 'homeHeadline') {
            this.clickedItem = e.target;

            return this.staticHandler();
        }

        this.toggleCallUpTip(true, e);

        return true;
    };

    loadMore = async () => {
        const { page, isEnd, content } = this.state;

        if (isEnd) return;

        const res = PAGE_INFO.api ? await getHotNewsData({ page, PAGE_INFO }) : { data: this.props.content.list };
        const data = res.data;

        if (window.allData.type === 'hot') {
            data.list.map(item => {
                item.kind = isFromHome ? 'inter_sflahuo04' : 'inter_fxy05';
                item.downloads = {
                    download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1447785374780',
                    downloadAd: `https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=${
                        isFromHome ? 8831 : 8778
                    }`,
                };
                item.clickCount = {
                    behavior: 'action',
                    type: 'click',
                    other: {
                        ref: `ucms_${item.base62Id}`,
                        kind: 'article',
                        url: encodeURIComponent(location.href),
                    },
                };

                // FIXME: 暂时兼容接口字段缺失
                item.url = `https://ishare.ifeng.com/c/s/${item.documentId.replace('ucms_', '')}`;

                return item;
            });
        }

        if (page === 1) {
            // 第一页
            this.init(data);
        } else {
            // 去重
            const allIds = content.list.map(item => item.documentId);

            data.list = content.list.concat(data.list.filter(item => !~allIds.indexOf(item.documentId)));
        }

        this.setState({ content: data, page: page + 1, isEnd: page + 1 > data.totalPage });
    };

    closeGuideFn = () => {
        h5PageCount([
            Object.assign(this.clickedItemInfo.clickCount, {
                type: 'cancelentry',
            }),
        ]);
        this.setState({ showCallUpTip: false });

        if (window.allData.unfoldType.hotNewsBreak === '2') {
            this.clickedItem.click();
        }
    };

    staticHandler = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const {
            content: { isVideoShare },
        } = this.props;
        const client = isVideoShare ? 'videoApp' : 'newsApp';
        const downloadVal = isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1447785374780',
                  downloadAd: `https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=${
                      isFromHome ? 8831 : 8778
                  }`,
              };

        this.setState({ showCallUpTip: false });
        this.enterSta();

        if (isCallApp) {
            callApp({
                client,
                docType: 'hotNewsRank',
                kind: isFromHome ? 'inter_sflahuo04' : 'inter_fxy05',
                pid: 'https://nine.ifeng.com/hotnewsrank',
                noKindFrom: 1,
                download: downloadVal.download,
                downloadAd: downloadVal.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    renderBanner(content, isClient) {
        const backgroundImg = (content && content.banner && content.banner.img) || '';
        const titleImg = (content && content.banner && content.banner.titleImg) || '';

        return (
            <div className={`${styles.hotNewsheader} ${isClient ? styles.appHeader : null}`}>
                <div className={styles.banner}>
                    {backgroundImg && <img src={backgroundImg} alt="" />}
                    {titleImg && <img src={titleImg} alt="" />}
                </div>
                {isClient ? (
                    <div className={styles.btn}>
                        <img
                            src={require('../assets/back_trans.png')}
                            alt=""
                            onClick={() => {
                                Grounds.close();
                            }}
                        />
                        <img
                            src={require('../assets/share_trans.png')}
                            alt=""
                            onClick={() => {
                                Grounds.openShare(
                                    'https://ishare.ifeng.com/hotNewsRank',
                                    content.shareInfo.desc,
                                    '来自凤凰新闻客户端',
                                    'https://x0.ifengimg.com/fe/custom/share.jpg',
                                    '',
                                );
                            }}
                        />
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        if (!this.state || !this.state.content) return null;

        const { content, type, showCallUpTip, show404Tips } = this.state;
        const { isClient } = this.state.allData;
        const {
            content: { isVideoShare, unfoldType, pageBottomPic },
        } = this.props;
        const wxLaunch = (unfoldType && unfoldType.wxLaunch) || {};
        const wxLaunchConfig = {
            wxLaunchType: wxLaunch.wxLaunchType === '1' ? 'app' : 'weapp',
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch === '1',
        };
        const CallUpTipTitle = isVideoShare
            ? '前往凤凰视频APP查看原文，体验更佳！'
            : '前往凤凰新闻APP查看原文，体验更佳！';
        const headerConfig = {
            isVideoShare,
            pageInfo: {
                type: 'hotNewsRank',
                id: 'https://nine.ifeng.com/hotnewsrank',
                kind: 'web',
                url: isBrowser ? location.href : '',
                position: 1,
                downloads: isVideoShare
                    ? {}
                    : {
                          download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                          downloadAd:
                              'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
                      },
            },
            topClickInfo: {
                behavior: 'action',
                type: 'upopen',
                kind: 'topic',
                callupKind: 'share01',
            },
            fixClickInfo: {
                behavior: 'action',
                type: 'grgxfc',
                kind: 'topic',
                callupKind: 'share01',
            },
            weappLink: 'pages/hotrank/hotrank.html?from=wxh5',
            hotKeyword: [
                '这条最新发布的内容，80%的网友都在看',
                '热热热！这条精彩内容，你的朋友们都在看',
                '过去24小时发生了这些好玩的事，点击查看',
                '全网最热新闻出炉，这些事儿你都知道吗？',
                '想不到！今天最火爆的新闻居然是……',
                '这条重磅新闻刚刚发布！快来查看',
                '过去的24小时你错过了这些重要新闻……',
                '今天这条消息，90%的人都不知道！',
            ],
            wxLaunchType: wxLaunchConfig.wxLaunchType,
            wxLaunchSwitch: wxLaunchConfig.wxLaunchSwitch,
        };
        const unfoldTypeNum = (unfoldType && unfoldType.hotNewsBreak) || '1';
        const unfoldTextInfo = (unfoldType && unfoldType.hotNewsBreakLayer) || {};
        const schemeLink =
            wxLaunchConfig.wxLaunchType === 'weapp'
                ? 'pages/hotrank/hotrank.html?from=wxh5'
                : getSchemeLink({
                      docType: 'hotNewsRank',
                      kind: 'inter_fxy05',
                      pid: 'https://nine.ifeng.com/hotnewsrank',
                      noKindFrom: 1,
                  });
        const brandPic = isVideoShare ? pageBottomPic.videoBrandPic : pageBottomPic.newBrandPic;
        const callAppConfig = brandPic
            ? {
                  docType: 'custom',
                  pid:
                      (pageBottomPic.schemeUrl && `${pageBottomPic.schemeUrl}&timeStamp=${new Date().getTime()}`) || '',
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1475599819841',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8826',
              }
            : {
                  docType: 'hotNewsRank',
                  kind: 'share01',
                  pid: 'https://nine.ifeng.com/hotnewsrank',
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
              };
        const actionConfig = brandPic
            ? [
                  {
                      behavior: 'action',
                      type: 'openapp_phtv',
                      other: {
                          ref: encodeURIComponent(location.href),
                          kind: 'hotRank',
                      },
                  },
              ]
            : [
                  {
                      behavior: 'action',
                      type: 'downopen',
                      other: {
                          ref: encodeURIComponent(location.href),
                          kind: 'hotRank',
                      },
                  },
              ];

        return (
            <div className={styles.container}>
                {isBrowser && !window.grounds ? (
                    <CallupHead
                        content={headerConfig}
                        closeCallback={() => {
                            this.setState({
                                scrollDirection: 'down',
                            });
                        }}
                    />
                ) : null}
                <FixedHeader isClient={isClient} content={content} />
                {this.renderBanner(content, isClient)}
                {!window.grounds && (
                    <PageBottomBrand
                        brandPic={brandPic}
                        isVideoShare={isVideoShare}
                        callAppConfig={callAppConfig}
                        actionConfig={actionConfig}
                        wxLaunchConfig={wxLaunch}
                    />
                )}
                <NewsFlow
                    isClient={isClient}
                    list={content.list}
                    handleCallUp={(e, force) => this.handleCallUp(e, force)}
                    loadMore={() => this.loadMore()}
                    storeClickedItem={item => this.storeClickedItem(item)}
                />
                <SimpleGuideLayer
                    isShowGuideLayer={showCallUpTip}
                    unfoldType={unfoldTypeNum}
                    unfoldTextInfo={unfoldTextInfo}
                    closeGuideFn={this.closeGuideFn}
                    gotoClientFn={this.staticHandler}
                    wxLaunchType={wxLaunchConfig.wxLaunchType}
                    wxLaunchSwitch={wxLaunchConfig.wxLaunchSwitch}
                    schemeLink={schemeLink}
                />
                {show404Tips ? (
                    <TipsNotFound
                        close={() => {
                            this.setState({
                                show404Tips: false,
                            });
                        }}
                    />
                ) : null}
                <Chip
                    id="170111"
                    type="struct"
                    title="点击查看更多展现形式"
                    groupName="点击查看更多展现形式"
                    translate="handleUnfoldTypeData"
                />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
